import { render, staticRenderFns } from "./tanchuang1.vue?vue&type=template&id=d4a7ec2e&scoped=true&"
import script from "./tanchuang1.vue?vue&type=script&lang=js&"
export * from "./tanchuang1.vue?vue&type=script&lang=js&"
import style0 from "./tanchuang1.vue?vue&type=style&index=0&id=d4a7ec2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a7ec2e",
  null
  
)

export default component.exports